import React from 'react'
import { connect as connectRedux } from 'react-redux'
import { Map, List } from 'immutable'
import { getBoundActions } from '../../actions/index'
import { CONTENT_IMAGE_TYPE_KEYART_WITH_TEXT } from '../../services/content/index'
import { TYPE_DISPLAY_GUIDE } from '../../services/content-type/index'
import TextSeasonEpisode from '../TextSeasonEpisode/index'
import Link from '../Link/index'
import Picture, { IMAGE_TYPE_WEBP, IMAGE_LOADING_LAZY } from '../Picture/index'
import { getMetaImageUrls } from './utils'

/**
 * @param {Object} props - The props
 * @param {Map} props.detailData - The content details data
 * @returns {JSX.Element} DetailPageV3MetaSeries
 */

const DetailPageV3MetaSeries = (props) => {
  const {
    detailData = Map(),
    staticText,
  } = props

  const season = detailData.get('seasonNumber')
  const episode = detailData.get('episodeNumber')
  const displayType = detailData.get('displayType')

  const images = detailData.get('images', List()) || List()
  const imageData = images.find((img) => img.get('type') === CONTENT_IMAGE_TYPE_KEYART_WITH_TEXT) || Map()
  const image = imageData.get('url', '')
  const imageWidth = '150'
  const imageHeight = '84'

  const { fallbackImageUrl, imageUrl } = getMetaImageUrls(image, imageWidth, imageHeight)

  return (
    <div className="detail-page-v3__meta-item detail-page-v3__meta-item-series">
      <div className="detail-page-v3__meta-item-series-image">
        <Picture
          fallbackSrc={fallbackImageUrl}
          width={'75'}
          height={'42'}
          alt={detailData.get('seriesTitle')}
          loading={IMAGE_LOADING_LAZY}
          sources={[
            {
              type: IMAGE_TYPE_WEBP,
              srcSet: imageUrl,
            },
          ]}
        />
      </div>
      <div className="detail-page-v3__meta-item-data">
        <p className="detail-page-v3__meta-item-label">
          {displayType === TYPE_DISPLAY_GUIDE
            ? <span>{`${staticText.get('lesson')} ${episode}`}</span>
            : <>
              <TextSeasonEpisode
                className={['detail-jumbotron__featured-season']}
                season={season}
                episode={episode}
              />
              <span>{` ${staticText.get('of')}`}</span>
            </>
          }
        </p>
        <p className="detail-page-v3__meta-item-text">
          <Link to={detailData.get('seriesPath')}>
            {detailData.get('seriesTitle')}
          </Link>
        </p>
      </div>
    </div>
  )
}

export default connectRedux((state) => ({
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3MetaSeries)
